export default "__VITE_ASSET__CGzfTpgy__"